import * as React from "react";
import { cn } from "../../lib/cn";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "flex w-full px-3 py-2 text-sm bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground transition-colors leading-relaxed",
        "focus:outline-none focus:border-ring focus:ring-2 focus:ring-ring/20",
        "disabled:opacity-40 disabled:cursor-not-allowed",
        "resize-y min-h-[120px]",
        className
      )}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";
